module.exports = __webpack_public_path__ + "img/folder.bebd2938.svg";